import { ListOnCallRequester } from '~/domain/usecases/onCallRequester/remote';
import {
  NotFound,
  BadRequestError,
  Forbidden,
  UnexpectedError,
  BadGateway,
} from '~/domain/errors';
import { HttpClient, HttpStatusCode } from '~/data/protocols/http';
import '~/infra/global/variables';

export class RemoteListOnCallRequester implements ListOnCallRequester {
  private readonly url: string;

  private readonly httpClient: HttpClient<ListOnCallRequester.Model>;

  constructor(url: string, httClient: HttpClient<ListOnCallRequester.Model>) {
    this.url = url;
    this.httpClient = httClient;
  }

  list = async (
    params: ListOnCallRequester.Params,
  ): Promise<ListOnCallRequester.Model> => {
    const httpResponse = await this.httpClient.request({
      url: this.url.replace('{onCallId}', params.onCallId.toString()),
      body: params.body,
      method: 'post',
    });
    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
      case HttpStatusCode.created:
      case HttpStatusCode.accepted:
      case HttpStatusCode.noContent:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.notFound:
        throw new NotFound();
      case HttpStatusCode.unauthorized:
        throw new Forbidden();
      case HttpStatusCode.badGateway:
        throw new BadGateway();
      default:
        throw new UnexpectedError();
    }
  };
}
